import { Alert, Classes } from "@blueprintjs/core";
import styled from "@emotion/styled";
import { useNavigate } from "react-router";

import { Box } from "@/components/layout/flexbox";

interface ErrorModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  errorMsg?: string;
  isBuyCreditRedirect: boolean;
}

export function ErrorModal({
  visible = false,
  onCancel,
  onConfirm,
  errorMsg = "",
  isBuyCreditRedirect = false,
}: ErrorModalProps) {
  const navigate = useNavigate();
  return (
    <Alert
      isOpen={visible}
      intent="danger"
      cancelButtonText={isBuyCreditRedirect ? "Close" : ""}
      confirmButtonText={isBuyCreditRedirect ? "Go to Buy Credits" : "Close"}
      style={{ width: "480px" }}
      onCancel={onCancel}
      onConfirm={() => (isBuyCreditRedirect ? navigate("/buy") : onConfirm())}
    >
      <StyledContainerList
        py={16}
        px={20}
        backgroundColor="#F6F6FB"
        fontSize="16px"
      >
        {errorMsg}
      </StyledContainerList>
    </Alert>
  );
}

const StyledContainerList = styled(Box)`
  .${Classes.BUTTON} {
    padding: 12px 19px;
    margin-right: 10px;
  }
  .${Classes.BUTTON_TEXT} {
    font-size: 16px;
  }

  .${Classes.FORM_GROUP} {
    margin: 0;
  }

  border-radius: 12px;
`;
